<!--
  @Description cgc 拼团mvp - 完单展示
-->
<template>
<div class="group_mvp_process_completed">
  <div class="left_wrap">
    <ProcessCompletedTitle />
  </div>
  <div class="right_wrap">
    <Prize
    :backgroundImg="backgroundImg && backgroundImg !== '' ? backgroundImg : defaultImg"
    :prizeDesc="prizeDesc"
    />
  </div>
</div>
</template>
<script>
import ProcessCompletedTitle from './group_mvp_process_completed_title'
import Prize from './group_mvp_process_prize'
export default {
  props: {
    backgroundImg: {
      type: String,
      default: () => ''
    },
    prizeDesc: {
      type: String,
      default: () => ''
    }
  },
  components: {
    ProcessCompletedTitle,
    Prize
  },
  computed: {
  },
  data () {
    return {
      defaultImg: require('../../../../assets/images/cgc/didi/mvp-gift-default.png')
    }
  }
}
</script>
<style scoped lang="stylus">
.group_mvp_process_completed
  width 620px
  height 160px
  background #FFFFFF
  border-radius 12px
  display flex
  justify-content space-between
  padding 32px 48px 0 32px
</style>